<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left col-lg-6 row p-0 m-0">
       <span class="col-lg-6 m-0 p-0 text-left"> 
         <button v-bind:class="{'font-weight-bold': status == ACTIVE_STATUS}" class="status-button" @click="status = ACTIVE_STATUS">{{ $t('active') }}</button> <span v-bind:class="{'font-weight-bold': status == ACTIVE_STATUS}">({{activeCount}})</span> | <button v-bind:class="{'font-weight-bold': status == DISABLED_STATUS}" class="status-button" href="#" @click="status = DISABLED_STATUS">{{ $t('disabled') }}</button> <span v-bind:class="{'font-weight-bold': status == DISABLED_STATUS}">({{disabledCount}})</span>
       </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary mr-2" @click="manageCategories">{{ $t('manageCategories') }}</button>
        <button type="button" class="btn btn-primary" @click="addPOI">{{ $t('addPoi') }}</button>
      </div>

    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="caption" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
    <!-- QR CODE -->
    <div class="qrcode" v-if="showModal">
      <h1 class="mb-5">{{$t("qrGenerated")}}</h1>
      <qrcode-vue id="mycanvas" :value="qrValue" :size="QR_SIZE" level="H" background="#ffffff" foreground="#000000"></qrcode-vue>
      <button type="button" class="btn btn-primary my-3" @click="downloadQr(value)">{{$t("download")}}</button>
      <button type="button" class="btn btn-primary" @click="showModal = false">{{$t("close")}}</button>
    </div>
  </div>

  
  
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '../controls/PaginatedTable.vue'
import SearchBar from '../controls/SearchBar.vue'
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import { convertToPascalCase } from "@/helpers/utils.js";
import i18n from '@/helpers/i18n';
import InputUpdateStatus from "@/classes/InputUpdateStatus";
import QrcodeVue from 'qrcode.vue';

const QR_SIZE = 300;
const CATEGORY_TYPE = "Poi";

const ACTIVE_STATUS = 'Active';
const DISABLED_STATUS = 'Inactive';

export default {
  components: { CTableWrapper, SearchBar, QrcodeVue },
  data () {
    return {
      qrValue: 'undefined',
      searchText: '',
      showModal: false,
      imageName: "teste",
      caption: i18n.t('pois'),
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'name', label: i18n.t('name'), _classes: 'font-weight-bold' },
        { key: 'categoryNames', label: i18n.t('categories'), sorter: false },
        { key: 'visits', label: i18n.t('totalVisits') },
      ],
      // These are only initialized on mounted according to the user role
      actions: [],
      status: '',
      sorterValue: { column: 'id', asc: false },
      loading: false,
      // Provide access to consts on HTML
      DISABLED_STATUS: DISABLED_STATUS,
      ACTIVE_STATUS: ACTIVE_STATUS,
      QR_SIZE: QR_SIZE
    }
  },
  computed: {
    ...mapState('configurations', ['configurationOutput']),
    ...mapState('pois', ['listOutput']),
    ...mapState('pois', ['processTask']),
    poisInfo: function() {
      return this.listOutput && this.listOutput.data ? this.listOutput.data : null;
    },
    items: function()
    {
      var result = [];

      if(this.poisInfo && this.poisInfo.pois)
      {
        result = this.poisInfo.pois;
        result.forEach(poi => {
          poi.categoryNames = poi.categories.map(x=> x.name).join(", ");
        });
      }

      return result;
    },
    pages: function()
    {
    return this.listOutput ? this.listOutput.totalPages : 1;
    },
    activeCount: function()
    {
      return this.poisInfo ? this.poisInfo.active : 0;
    },
    pendingCount: function()
    {
      return this.poisInfo ? this.poisInfo.pending : 0;
    },
    disabledCount: function()
    {
      return this.poisInfo ? this.poisInfo.inactive : 0
    },
    configurationPoi: function()
    {
      return this.configurationOutput;
    },
    prefixPoi: function()
    {
      return this.configurationOutput.data.prefix;
    }

  },
  mounted: function()
  {
    this.getConfiguration();
    this.status = this.ACTIVE_STATUS; // This will triger an updateItemsRequested
  },
  methods: {
    downloadQr (value) 
    {
      let canvasImages =document.getElementsByTagName('canvas');
      
      let canvasImage =canvasImages[0].toDataURL('image/png');

      // this can be used to download any image from webpage to local disk
      let xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = value+'.jpg';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove()
      };
      xhr.open('GET', canvasImage); // This is to download the canvas Image
      xhr.send();
      this.showModal = false;
    },
    ...mapActions('configurations', ['getConfiguration']),
    ...mapActions('pois', ['getList']),
    ...mapActions('pois', ['updateStatus']),
    rowClicked (item, index) {
          
      this.$router.push({name: "EditPoi", params: { poi: item} });
         
    },
    actionClicked(item, action){
      var inputUpdateStatus = new InputUpdateStatus(item.id);

      switch(action.key)
      {
        case 'qrcode':
        {
          this.qrValue = this.prefixPoi +"-"+ item.id;
          this.showModal = true;
          break;
        }
        case 'view':
        {
          this.$router.push({name: "EditPoi", params: { poi: item } });
          break;
        }
        case 'disable':
        {
          if(confirm(this.$i18n.tc('confirmDisable', item.name, { name: item.name }))){
            inputUpdateStatus.status = DISABLED_STATUS;
          }
          break;
        }
        case 'activate':
        {
          if(confirm(this.$i18n.tc('confirmApprove', item.name, { name: item.name }))){
            inputUpdateStatus.status = ACTIVE_STATUS;
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }

      if(inputUpdateStatus.status != undefined)
      {
        this.updateStatus(inputUpdateStatus);
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));

      // List specific parameters
      input.status = this.status;

      this.getList(input); 
    },
    addPOI () 
    { 
      router.push({ path: '/pois/add' });
    },
    manageCategories()
    {
      this.$router.push({name: "ListCategories", params: { type: CATEGORY_TYPE } });
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }
  },
  watch: 
  {  
    status: function (val) {
      // Update actions
      switch(val) {

        case ACTIVE_STATUS:
        {
          this.actions = [];        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'disable', label: this.$i18n.t("disable") });
          this.actions.push({ key: 'qrcode', label: this.$i18n.t("qrcode") });
          
          break;
        }
        case DISABLED_STATUS:
        {
          this.actions = [];
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'activate', label: this.$i18n.t("activate") });
          this.actions.push({ key: 'qrcode', label: this.$i18n.t("qrcode") });

          break;
        }
        default:
        {
          throw "The provided status is not supported!"; 
        }
      }

      // Update items
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    processTask: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    listOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}

.qrcode
{
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;        
}

.qrcode > h1 
{
  color: #fff;
}
</style> 